import React from "react";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';

class ContactUs extends React.Component
{
    render()
    {
        return <>
        <div id="ContactScreen"> 
            <h1>GET IN TOUCH</h1>
            <h3>Explore The Profession With Us</h3>
        </div>
        <div className='contactScreenDiv'> 
            {this.buildHyderbadContact()}
            {this.buildBangaloreContact()}
        </div>    
                </>    
    }

    buildHyderbadContact()
    {
        return <div className='detailsSection'>
        <h1>Hyderabad</h1>
        <div>
        <div className="locationAddress">
            <p className="locationIcon"><LocationOnOutlinedIcon/></p>
            <p className="locationAdr">16-11-19/2/5, behind Yes Bank, Saleem Nagar Colony, Malakpet Extension, New Malakpet, Hyderabad, Telangana - 500036</p>
        </div>
        <div className="location_Email">
            <p className="locationIcon"><MailOutlinedIcon/></p>
            <p className="locationEmail">universalbartendingacademy@gmail.com</p>
        </div>
        <div className="location_Phone">
            <p className="locationIcon"><CallOutlinedIcon/></p>
            <p className="locationEmail">+91 8179280386 /+91 8179280385</p>
        </div>
        </div>
        <div className='embeddedMap'>
        <iframe className='ubaMap' title="location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121814.34806510647!2d78.3630182883178!3d17.42625681906061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99a7f3632149%3A0x381a3f52d1779a80!2sUniversal%20Bartending%20Academy%20Hyderbad!5e0!3m2!1sen!2sin!4v1693728645668!5m2!1sen!2sin"></iframe>
    </div>
    </div>
}

 buildBangaloreContact()
    {
        return <div className='detailsSection'>
                    <h1>Nizamabad</h1>
                    <div>
                    <div className="locationAddress">
                        <p className="locationIcon"><LocationOnOutlinedIcon/></p>
                        <p className="locationAdr">6-2-129, laxmi nivas,2nd floor,zp road, Subhash nagar, Nizamabad-503002</p>
                    </div>
                    <div className="location_Email">
                        <p className="locationIcon"><MailOutlinedIcon/></p>
                        <p className="locationEmail">ubanzb@gmail.com</p>
                    </div>
                    <div className="location_Phone">
                        <p className="locationIcon"><CallOutlinedIcon/></p>
                        <p className="locationEmail">+91 8179280385 /+91 8179280386</p>
                    </div>
                    </div>
                    <div className='embeddedMap'>
            <iframe className='ubaMap' title="location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3779.562808911271!2d78.1113924!3d18.6836046!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcdc5cad13d9f4d%3A0x6648334a53bfd90b!2sUniversal%20Bartending%20Academy%20Nizamabad!5e0!3m2!1sen!2sin!4v1772381890455!5m2!1sen!2sin"></iframe>
                </div>
                </div>
    }

    }   


export default ContactUs;